/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AktenzeichenInputs */

const de__field_aktenzeichen = /** @type {(inputs: _Field_AktenzeichenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktenzeichen`)
};

/**

* @param {_Field_AktenzeichenInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_aktenzeichen = /** @type {((inputs?: _Field_AktenzeichenInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AktenzeichenInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_aktenzeichen(inputs)
});